import { render, staticRenderFns } from "./banner-img.vue?vue&type=template&id=57105cd5&scoped=true&"
import script from "./banner-img.vue?vue&type=script&lang=js&"
export * from "./banner-img.vue?vue&type=script&lang=js&"
import style0 from "./banner-img.vue?vue&type=style&index=0&id=57105cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57105cd5",
  null
  
)

export default component.exports